import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_HOST;




export const getProductCategorylist = async ({
  page = 1,
  limit = 10,
  search = "",
}) => {
  const token = localStorage.getItem("access_token");
  const response = await axios.get(`${API_BASE_URL}/category`, {
    params: {
      page,
      limit,
      ...(search && { search }), 
    },
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
  const resData = response.data.data;

  return {
    data: resData.data,
    currentPage: resData.current_page,
    lastPage: resData.last_page,
    perPage: resData.per_page,
    total: resData.total,
    nextPageUrl: resData.next_page_url,
    prevPageUrl: resData.prev_page_url,
  };
};


export const Menulist = async ({ page = 1, limit = 10 }) => {
  const token = localStorage.getItem("access_token");

  const response = await axios.get(`${API_BASE_URL}/menu`, {
    params: { page, limit },
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  });

  const resData = response.data.data;

  return {
    data: resData.data,
    currentPage: resData.current_page,
    lastPage: resData.last_page,
    perPage: resData.per_page,
    total: resData.total,
    nextPageUrl: resData.next_page_url,
    prevPageUrl: resData.prev_page_url,
  };
};

export const addCategory = async (formData) => {
  const token = localStorage.getItem("access_token");
  const response = await axios.post(`${API_BASE_URL}/category/add`, formData, {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
  return response.data;
};

export const updateCategory = async (formData) => {
  const token = localStorage.getItem("access_token");

  try {
    const response = await axios.post(`${API_BASE_URL}/category/update`, formData, {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error updating product:", error);
    throw error;
  }
};

export const getCategoryById = async (id) => {
  const token = localStorage.getItem("access_token");

  try {
    const response = await axios.get(`${API_BASE_URL}/category/show/${id}`, {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching product:", error);
    throw error;
  }
};


export const deleteCategoryById = async (id) => {
  const token = localStorage.getItem("access_token");
  const response = await axios.get(`${API_BASE_URL}/category/delete/${id}`, {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
  return response.data;
};




export const getProductSpecifications = async (
  productId,
  page = 1,
  limit = 10,
  search = "",
) => {
  const token = localStorage.getItem("access_token");
  if (!token) {
    console.error("Access token missing");
    return;
  }
  const response = await axios.get(
    `${API_BASE_URL}/product/specifications/${productId}`,
    {
      params: {
        page,
        limit,
        ...(search && { search }), 
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};




export const addProductSpecification = async (data) => {
  const token = localStorage.getItem("access_token");

  const response = await axios.post(
    `${API_BASE_URL}/product/addSpecification`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};


export const updateProductSpecification = async (payload) => {
  const token = localStorage.getItem("access_token");

  return axios.post(
    `${API_BASE_URL}/product/updateSpecification`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};





export const getSpecificationsById = async (id) => {
  const token = localStorage.getItem("access_token");

  try {
    const response = await axios.get(`${API_BASE_URL}/product/showSpecification/${id}`, {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching product:", error);
    throw error;
  }
};




export const deleteProductSpecification = async (id) => {
  const token = localStorage.getItem("access_token");
  const response = await axios.get(`${API_BASE_URL}/product/deleteSpecification/${id}`, {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
  return response.data;
};




export const getProduct = async (
  typeId,
  page = 1,
  limit = 10
) => {
  const token = localStorage.getItem("access_token");
  if (!token) {
    throw new Error("Access token missing");
  }

  // console.log("API Call - URL:", `${API_BASE_URL}/products/types/${typeId}`);
  // console.log("API Call - Params:", { limit, page });

  try {
    const response = await axios.get(
      `${API_BASE_URL}/product/${typeId}`,
      {
        params: {
          limit,
          page,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (error) {
    console.error("API Error:", error.response || error);
    throw error;
  }
};



export const deleteProductListType = async (id) => {
  const token = localStorage.getItem("access_token");
  const response = await axios.get(`${API_BASE_URL}/product/delete/${id}`, {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
  return response.data;
};



export const addProduct = async (data) => {
  const token = localStorage.getItem("access_token");

  const response = await axios.post(
    `${API_BASE_URL}/product/add`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};


export const updateProduct = async (payload) => {
  const token = localStorage.getItem("access_token");

  return axios.post(
    `${API_BASE_URL}/product/update`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};


export const getProductTypeById = async (id) => {
  const token = localStorage.getItem("access_token");

  try {
    const response = await axios.get(`${API_BASE_URL}/product/show/${id}`, {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching product:", error);
    throw error;
  }
};








export const getProductTypeSpecifications = async (
  productId,
  page = 1,
  limit = 10
) => {
  const token = localStorage.getItem("access_token");

  if (!token) {
    console.error("Access token missing");
    return;
  }

  const response = await axios.get(
    `${API_BASE_URL}/products/types/specifications/${productId}`,
    {
      params: { page, limit },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};



export const addProductTypeSpecification = async (data) => {
  const token = localStorage.getItem("access_token");

  const response = await axios.post(
    `${API_BASE_URL}/products/types/addSpecification`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};


export const updateProductTypeSpecification = async (payload) => {
  const token = localStorage.getItem("access_token");

  return axios.post(
    `${API_BASE_URL}/products/types/updateSpecification`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};





export const getProductTypeSpecificationsById = async (id) => {
  const token = localStorage.getItem("access_token");

  try {
    const response = await axios.get(`${API_BASE_URL}/products/types/showSpecification/${id}`, {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching product:", error);
    throw error;
  }
};




export const deleteProductTypeSpecification = async (id) => {
  const token = localStorage.getItem("access_token");
  const response = await axios.get(`${API_BASE_URL}/products/types/deleteSpecification/${id}`, {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
  return response.data;
};






export const getCategoryTypeSpecifications = async (
  productId,
  page = 1,
  limit = 10,
  search = ""
) => {
  const token = localStorage.getItem("access_token");

  const response = await axios.get(
    `${API_BASE_URL}/category/specifications/${productId}`,
    {
      params: {
        page,
        limit,
        ...(search && { search }),
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};


export const addCategoryTypeSpecification = async (data) => {
  const token = localStorage.getItem("access_token");

  const response = await axios.post(
    `${API_BASE_URL}/category/specifications/add`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};

export const updateCategoryTypeSpecification = async (payload) => {
  const token = localStorage.getItem("access_token");

  return axios.post(
    `${API_BASE_URL}/category/specifications/update`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const deleteCategorySpecification = async (id) => {
  const token = localStorage.getItem("access_token");
  const response = await axios.get(`${API_BASE_URL}/category/specifications/delete/${id}`, {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
  return response.data;
};

export const getCategorySpecificationsById = async (id) => {
  const token = localStorage.getItem("access_token");

  try {
    const response = await axios.get(`${API_BASE_URL}/category/specifications/show/${id}`, {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching product:", error);
    throw error;
  }
};









export const getProductBenifit = async (
  productId,
  page = 1,
  limit = 10,
  search = ""
) => {
  const token = localStorage.getItem("access_token");

  if (!token) {
    console.error("Access token missing");
    return;
  }

  const response = await axios.get(
    `${API_BASE_URL}/product/benefits/${productId}`,
    {
      params: {
        page,
        limit,
        ...(search && { search }), 
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};







export const addProductTypeBenifit = async (data) => {
  const token = localStorage.getItem("access_token");

  const response = await axios.post(
    `${API_BASE_URL}/product/addBenefit`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};


export const updateProductTypeBenifit = async (payload) => {
  const token = localStorage.getItem("access_token");

  return axios.post(
    `${API_BASE_URL}/product/updateBenefit`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};







export const getProductTypeBenifitById = async (id) => {
  try {
    if (!id) {
      throw new Error("Product Type Benefit ID is required");
    }

    const token = localStorage.getItem("access_token");

    if (!token) {
      throw new Error("Access token not found");
    }

    const response = await axios.get(
      `${API_BASE_URL}/product/showBenefit/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      "Error fetching product type benefit:",
      error?.response?.data || error.message
    );
    throw error;
  }
};






export const deleteProductTypeBenifits = async (id) => {
  const token = localStorage.getItem("access_token");
  const response = await axios.get(`${API_BASE_URL}/product/deleteBenefit/${id}`, {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
  return response.data;
};
